const BUSINESS_SUFFIXES = new Set([
  'co',
  'company',
  'corp',
  'corporation',
  'inc',
  'incorporated',
  'llc',
  'llp',
  'lp',
  'ltd',
  'pllc',
]);

export function workspaceInitials(value) {
  const words = String(value || '')
    .trim()
    .split(/\s+/)
    .map(word => word.replace(/[^\p{L}\p{N}]/gu, ''))
    .filter(Boolean);
  const meaningfulWords = words.filter(word => !BUSINESS_SUFFIXES.has(word.toLowerCase()));
  const candidates = meaningfulWords.length ? meaningfulWords : words;

  if (!candidates.length) return '';
  if (candidates.length === 1) return candidates[0][0].toUpperCase();
  return `${candidates[0][0]}${candidates[candidates.length - 1][0]}`.toUpperCase();
}
